/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Grid from '@material-ui/core/Grid';
import {
    object, number, string, shape, arrayOf, bool,
} from 'prop-types';
import Divider from '@material-ui/core/Divider';
import ImageModal from './ImageModal';
import  StatusTracking from '../../common/StatusTracking';
import AddressHelper from '../OrderDetails/Helper/AddressHelper';
import { dateMMMMDDYYYY } from '../../utils/dateString';
import configENV from '../../config';
import { isEmpty } from '../../utils/object';

import { secureProtocol } from '../../utils/secureProtocol';
import { getDataDictionary } from '../../../../../state/ducks/App/App-Selectors';
import { getLanguageName } from '../../../../../state/ducks/Member/ducks/Auth/helper/helper';

const { PERSIST_KEY } = configENV;

class MobileOrderListItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            openModal: false,
        };
    }

    render() {
        const {
            items, index, userProfile, brand, dataDictionary,
        } = this.props;
        const {
            openModal,
        } = this.state;
        if (!userProfile) {
            return null;
        }
        const {
            id, status, paymentStatus, itemDetailList, recipientDetail,
        } = items;

        // There is a discrepancy of Order Details' API response between login and guest account.
        let {
            prdImgCtg, productName, productSku, deliveryDate,
        } = items;

        if (!isEmpty(itemDetailList)) {
            ([{
                productName, prdImgCtg, productSku, deliveryDate,
            }] = itemDetailList);
        }

        const productImageURL = prdImgCtg ? secureProtocol(prdImgCtg) : prdImgCtg;
        const language = getLanguageName();
        return (
            <React.Fragment key={id}>
                <Grid container className="orderItemGrid">
                    <Grid container>
                        <Grid className="orderStatusInfo" item xs={12}>
                            {index === 0 && (
                                <Grid container>
                                    <Grid item xs={12}>
                                        <StatusTracking
                                            status={status || paymentStatus}
                                            brand={brand}
                                            trackingMobile
                                        />
                                    </Grid>
                                </Grid>
                            )}
                        </Grid>
                        <Grid className="productInnerDiv" item xs={12}>
                            <div className="headerItemLabel">
                                {language === '/en' ? 'Product Information' : dataDictionary?.['Product Information'] || 'Product Information'}
                            </div>
                            <div className="productContainer">
                                <div className="productTitle">
                                    {language === '/en' ? 'Product Name' : dataDictionary?.['Product Name'] || 'Product Name'}
                                    <button type="button" className="productLink" onClick={() => { this.setState({ openModal: true }); }}>{productName}</button>
                                    <ImageModal isOpen={openModal} onClose={() => { this.setState({ openModal: false }); }} productImageURL={productImageURL} productSku={productSku} />
                                </div>
                                <div className="productTitle">
                                    {language === '/en' ? 'Delivery Address' : dataDictionary?.['Delivery Address'] || 'Delivery Address'}
                                    <AddressHelper address={recipientDetail?.address} />
                                </div>
                                <div className="productTitle">
                                    {language === '/en' ? 'Delivery Date' : dataDictionary?.['Delivery Date'] || 'Delivery Date'}
                                    <div className="productInfo">{deliveryDate && dateMMMMDDYYYY(deliveryDate, dataDictionary)}</div>
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                </Grid>
                <Divider />
            </React.Fragment>
        );
    }
}
MobileOrderListItem.propTypes = {
    items: shape({
        brandId: string,
        productSku: string,
        productName: string,
        recpFirstName: string,
        recpLastName: string,
        shipDate: string,
        paymentStatus: string,
        estimatedDeliveryDate: string,
        trackingNumber: string,
        itemType: string,
        sfItemType: string,
        addonType: string,
        parentLineNumber: string,
        childLineNumber: string,
        flexDate: string,
        flexMessage: string,
        flexGuaranteedFlag: string,
        prdImgCtg: string,
        prdImgTmn: string,
        arrivalStartDate: string,
        arrivalEndDate: string,
        carrier: string,
        subscriptionType: string,
        interval: string,
        duration: string,
        modifyOrder: string,
        status: string,
        itemDetailList: arrayOf(
            shape({
                cardMessage: string,
                productName: string,
                productSku: string,
                productBrand: string,
                price: string,
                itemType: string,
                sfItemType: string,
                addonType: string,
                parentLineNumber: string,
                childLineNumber: string,
                prdImgCtg: string,
                prdImgTmn: string,
            }),
        ),
    }).isRequired,
    index: number.isRequired,
    userProfile: shape({
        isAuthenticated: bool.isRequired,
    }).isRequired,
    brand: object.isRequired,
    dataDictionary: object.isRequired,
};

const mapStateToProps = (state) => {
    /* istanbul ignore next */
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    return {
        isAuthenticated: newState.isAuthenticated,
        dataDictionary: getDataDictionary(state),
    };
};

export default connect(
    mapStateToProps,
    null,
)(withRouter(MobileOrderListItem));
